<template>
  <div class="page">
    <div class="about">
      <div class="about-top">
        <div class="aboutTitle">{{ props.data.titleCn }}</div>
        <div class="aboutEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="about-bottom">
        <div class="about-left">
          <div class="aboutContent" v-html="props.data.contentText"></div>
        </div>
        <div class="about-right">
          <img :src="props.data.imgUrl" alt="" class="aboutBg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .about {
    width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 116px;
    .about-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .aboutTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .aboutEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .about-bottom{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      .about-left {
        width: 870px;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        .aboutContent{
          color: rgb(44, 44, 44);
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: 400;
          line-height: 36px;
          letter-spacing: 0px;
          text-align: justify;
          text-transform: uppercase;
        }
      }
      .about-right {
        width: 495px;
        img{
          width: 100%;
        }
      }
    }
  }
}
</style>
